export default {
  claimRewardSelectAllCheckbox: 'layout-claim-reward-select-all-checkbox',
  claimRewardOpenModalButton: 'layout-claim-reward-open-modal-button',
  claimRewardBreakdown: 'layout-claim-reward-breakdown',
  claimRewardSubmitButton: 'layout-claim-reward-submit-button',
};
